import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { cities } from '../data/cities';
import { FaStar, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import '../styles/CityDetails.css';

const CityDetails: React.FC = () => {
  const { cityId } = useParams<{ cityId: string }>();
  const city = cities.find(c => c.id === cityId);

  if (!city) {
    return (
      <div className="container">
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <div className="city-details">
      <div className="city-hero">
        <div className="hero-image-container">
          <img 
            src={city.image} 
            alt={city.name} 
            className="hero-image"
          />
          <div className="hero-content">
            <h1>{city.name}</h1>
            <p>{city.description}</p>
            <div className="city-rating">
              <FaStar className="star-icon" />
              <span>{city.rating}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container section">
        <div className="city-info-grid">
          <div className="info-card card">
            <h3>
              <FaMapMarkerAlt className="info-icon" />
              Best Time to Visit
            </h3>
            <p>{city.bestTimeToVisit}</p>
          </div>
          <div className="info-card card">
            <h3>
              <FaStar className="info-icon" />
              Famous For
            </h3>
            <ul>
              {city.famousFor.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <h2>Tourist Attractions</h2>
        <div className="places-grid">
          {city.attractions.map((attraction, index) => (
            <Link 
              key={index} 
              to={`/city/${cityId}/spot/${attraction.toLowerCase().replace(/\s+/g, '-')}`} 
              className="place-card card"
            >
              <div className="place-info">
                <h3>{attraction}</h3>
                <div className="place-card-content">
                  <div className="rating">
                    <FaStar className="star-icon" />
                    <span>{city.rating}</span>
                  </div>
                  <FaArrowRight className="arrow-icon" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CityDetails;